import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Who installs countertops near me in Salt Lake County?',
      answer: 'A-One Solid Surfacing provides professional countertop installation throughout Salt Lake County, including West Valley City, Salt Lake City, Park City, Sandy, Draper, and surrounding areas. We have over 30 years of experience installing custom quartz, granite, and porcelain countertops for residential and commercial properties.'
    },
    {
      question: 'What countertop materials last the longest?',
      answer: 'Porcelain and quartz countertops offer exceptional durability and longevity, often lasting 25+ years. Porcelain is heat-resistant, scratch-proof, and stain-resistant, while quartz provides a non-porous surface that requires minimal maintenance. Granite countertops also offer excellent durability when properly sealed and maintained.'
    },
    {
      question: 'How much do quartz countertops cost in Utah?',
      answer: 'Quartz countertop costs in Utah typically range from $60-$150 per square foot installed, depending on color, pattern, edge profile, and project complexity. Contact A-One Solid Surfacing for a free estimate. We offer competitive pricing and 10% discounts for veterans and first responders on all countertop installations.'
    },
    {
      question: 'What is the best countertop material for kitchens?',
      answer: 'The best kitchen countertop depends on your lifestyle and preferences. Quartz offers superior durability and low maintenance with consistent patterns. Granite provides natural beauty with unique veining. Porcelain delivers exceptional heat and scratch resistance. Our experts help you choose the perfect material for your kitchen based on your cooking habits, design preferences, and budget.'
    },
    {
      question: 'What is the difference between porcelain and quartz countertops?',
      answer: 'Porcelain countertops are made from natural clay fired at extremely high temperatures, making them heat-resistant and ideal for high-heat cooking. Quartz countertops are engineered stone made from 90-95% natural quartz mixed with resins, offering consistent patterns and non-porous surfaces. Both are excellent choices with different aesthetic and performance characteristics.'
    },
    {
      question: 'Do you install countertops for commercial properties?',
      answer: 'Yes, we specialize in both residential and commercial countertop installations throughout Salt Lake County. Our materials and digital fabrication methods are designed to withstand heavy daily use in restaurants, hotels, offices, and retail spaces while maintaining a clean, professional appearance. We are OSHA compliant and fully licensed and insured for commercial projects.'
    },
    {
      question: 'How long does countertop installation take?',
      answer: 'Most countertop installations are completed within 1-2 days after fabrication, depending on the size and complexity of the project. The complete process from consultation to installation typically takes 2-3 weeks. We also offer same-day service for urgent projects. Our team works efficiently to minimize disruption to your daily routine.'
    },
    {
      question: 'What are the benefits of stone countertops?',
      answer: 'Stone countertops offer numerous benefits including exceptional durability, heat resistance, scratch resistance, and timeless beauty. Natural stone like granite provides unique patterns, while engineered stone like quartz offers consistent appearance and low maintenance. Stone countertops increase home value, resist bacteria when properly sealed, and can last decades with proper care.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked <span className="text-amber-600">Questions</span>
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our <strong>countertop installation services</strong> in <strong>Salt Lake County, Utah</strong>
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-amber-600 flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Still have questions about <strong>countertop installation</strong>?</p>
          <a 
            href="tel:801-706-1610"
            className="inline-flex items-center space-x-2 bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-amber-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>Call Us: 801-706-1610</span>
          </a>
        </div>
      </div>
    </section>
  );
}